module.exports = __webpack_public_path__ + "img/headline.7141db73.svg";